import { EntityType } from "../entity.js";
export function attachmentIngestEventReducer(oldAttachment, event) {
    if (oldAttachment) {
        return oldAttachment;
    }
    else {
        return {
            id: event.entityID,
            createdAtTimestampMillis: event.timestampMillis,
            type: EntityType.AttachmentReference,
            mimeType: event.mimeType,
        };
    }
}
//# sourceMappingURL=attachmentReducers.js.map